var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('span',{staticClass:"text-12p text-gray-light 2xl:text-14p select-none"},[_vm._v(_vm._s(_vm.label))])]),_c('div',[_c('span',{staticClass:"text-14p 2xl:text-16p select-none",domProps:{"innerHTML":_vm._s(_vm.value)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }